export const MODAL_PARAM_KEY = 'm';
export const STORY_MODAL_PARAM_KEY = 's';
export const SLIDE_IN_PANEL_PARAM_KEY = 'sip';

export const PRODUCT_MODALS = {
  AMENDMENT: 'amendment',
  ANNUAL_REPORT: 'annualReport',
  BANK_OF_AMERICA_OFFER: 'bankOfAmericaOffer',
  BANKING_RESOLUTION_TEMPLATE: 'bankingResolutionTemplate',
  BENEFICIAL_OWNERSHIP_FILING: 'beneficialOwnershipFiling',
  BUSINESS_BANK_ACCOUNT: 'businessBankAccount',
  BUSINESS_DOCUMENTS: 'businessDocuments',
  BUSINESS_LICENSE_REPORT: 'businessLicenseReport',
  CHASE_OFFER: 'chaseOffer',
  CORP_BUSINESS_KIT: 'corpBusinessKit',
  CORP_BYLAWS: 'corporateBylaws',
  DBA_ENTITY: 'dbaEntity',
  DOMAIN_NAME_PRIVACY: 'domainNamePrivacy',
  DOMAIN_NAME_REG: 'domainNameReg',
  EIN_CREATION: 'einCreation',
  EMAIL: 'email',
  ENTITY_NAME_RESERVATION: 'entityNameReservation',
  GRANT_APPLICATION: 'grantApplication',
  LEGAL_SHIELD: 'legalShield',
  LLC_BUSINESS_KIT: 'llcBusinessKit',
  LOGO_KIT: 'logoKit',
  MICROSOFT_365_PROMO: 'microsoft365Promo',
  NY_PUBLICATION: 'nyPublication',
  OCOYA_SOCIAL_MEDIA: 'ocoyaSocialMedia',
  ONLINE_NOTARY_SERVICE: 'onlineNotaryService',
  OPERATING_AGREEMENT: 'operatingAgreement',
  REGISTERED_AGENT: 'registeredAgent',
  STANDARD_GOOD_STANDING: 'standardGoodStanding',
  TAX_SERVICES: 'taxServices',
  WEBSITE_DUDA: 'websiteDuda',
  WEBSITE_TOOLS_BUNDLE: 'websiteToolsBundle',
  WEBSITE: 'website',
  WFG_INITIAL_REPORT: 'wfgInitialReport',
  WORRY_FREE_SERVICE: 'worryFreeService',
  ZB_CHECKING_PREFERRED: 'checkingPreferred',
  ZEN_BUSINESS_MONEY: 'zenBusinessMoney',
};

export const PRODUCT_SERVICE_NAME = {
  BANK_OF_AMERICA_OFFER: 'bank_of_america_offer',
  BANKING_RESOLUTION_TEMPLATE: 'banking_resolution',
  BASIC_EMAIL: 'basic_email',
  BENEFICIAL_OWNERSHIP_FILING: 'beneficial_ownership_filing',
  BUSINESS_CREDIT_CARD: 'business_credit_cards',
  BUSINESS_DOCUMENTS: 'corporate_docs',
  BUSINESS_KIT: 'business_kit',
  BUSINESS_LICENSE_REPORT: 'business_license_report',
  CORP_AMENDMENT: 'corp_amendment',
  CORP_ANNUAL_REPORT: 'corp_annual_report',
  DBA_ENTITY: 'dba_entity',
  DOMAIN_NAME_PRIVACY: 'domain_name_privacy',
  DOMAIN_NAME_REG: 'domain_name_reg',
  DOMAIN_NAME_REG_SQSP: 'domain_name_reg_sqsp',
  EIN_CREATION: 'ein_creation',
  ENTITY_NAME_RESERVATION: 'entity_name_reservation',
  INITIAL_REPORT: 'wfg_initial_report',
  LEGAL_SHIELD: 'legal_shield',
  LLC_AMENDMENT: 'llc_amendment',
  LLC_ANNUAL_REPORT: 'llc_annual_report',
  LOGO_KIT: 'logo_kit',
  NEXT_INSURANCE_OFFER: 'next_insurance_offer',
  NY_PUBLICATION: 'ny_publication',
  OPERATING_AGREEMENT: 'operating_agreement',
  REGISTERED_AGENT: 'registered_agent_service',
  STANDARD_GOOD_STANDING: 'standard_good_standing',
  ZB_TAX_ADVICE: 'zb_tax_advice',
  ZB_TAX_ADVICE_BIZTAX_PREP: 'zb_tax_advice_biztax_prep',
  ZB_BIZTAX_PREP: 'zb_biztax_prep',
  WEBSITE: 'static_website',
  WEBSITE_TOOLS_BUNDLE: 'website_tools_bundle',
  WORRY_FREE_SERVICE: 'worry_free_service',
  ZB_CHECKING_PREFERRED: 'zb_banking_preferred',
  ZB_MONEY_PRO: 'zb_money_pro',
};

export const DBA_IGNORE_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'MN',
  'NC',
  'ND',
  'NE',
  'NM',
  'NV',
  'PA',
  'SC',
  'TN',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];

export const SIMULATED_NAME = 'My Business';

// keeping this key name for legacy reasons
// file deepcode ignore HardcodedNonCryptoSecret: This is not a secret
export const BUSINESS_CARD_OFFER_STORAGE_KEY = 'zb.upsell.Chase.CreditCards';

export const HAS_STARTED_EDUCATION_STORIES = 'hasStartedEducationStories';

export const HAS_STARTED_INVOICE_STORIES = 'hasStartedInvoiceStories';

export const ZB_MONEY_PRO = 'zb_money_pro';
export const ZB_MONEY_ESSENTIAL = 'zb_money_essential';
export const ZB_MONEY_UNLINKED = 'none';

export const ZB_MONEY_CONTEXT_DEFAULTS = {
  accountTier: ZB_MONEY_UNLINKED,
  isPlaidLinked: false,
};
